import { ArchivedDocumentWithDetails, VisibleColumnSpec } from "@/types";

export const DEFAULT_ORDER_DOCUMENTS_COLUMN: VisibleColumnSpec<ArchivedDocumentWithDetails>[] = [
  "documentType",
  "documentTitle",
  "fileType",
];
